import React, { useCallback, useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import CommonTabSwitcher from 'components/commonTabSwitcher/CommonTabSwitcher';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { sideBarRoutes } from 'utils/StaticData';
import { FaBuilding, FaHandshake, FaUser } from 'react-icons/fa';
import EInvoiceList from './EInvoiceList';
import SalesPartnerInvoiceList from './SalesPartnerInvoiceList';

const EInvoiceTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { adminDetails } = useSelector((state) => state.authSlice);
  const isAccess =
    adminDetails?.role === sideBarRoutes?.Admin ||
    adminDetails?.role === sideBarRoutes?.Dealer ||
    adminDetails?.role === sideBarRoutes?.Seller;

  const tabIndex = useMemo(() => {
    const t = searchParams.get('tab');
    const parsed = t ? Number(t) : 0;
    const maxTab = isAccess ? 2 : 1;
    return parsed > maxTab ? 0 : parsed;
  }, [searchParams, isAccess]);

  const setTabIndex = useCallback(
    (index) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (index === 0) {
            next.delete('tab');
          } else {
            next.set('tab', String(index));
          }
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  const tabs = [
    { label: 'Merchant Invoices (B2B)', icon: FaBuilding },
    { label: 'Customer Invoices (B2C)', icon: FaUser },
    ...(isAccess
      ? [{ label: 'Sales Partner Invoices', icon: FaHandshake }]
      : []),
  ];

  return (
    <Box pt={{ base: '60px', md: '80px', xl: '80px' }}>
      <CommonTabSwitcher
        tabs={tabs}
        activeIndex={tabIndex}
        onChange={setTabIndex}
      />
      {tabIndex === 0 && <EInvoiceList invoiceType="B2B" isActive={true} />}
      {tabIndex === 1 && <EInvoiceList invoiceType="B2C" isActive={true} />}
      {isAccess && tabIndex === 2 && (
        <SalesPartnerInvoiceList isActive={true} />
      )}
    </Box>
  );
};

export default EInvoiceTabs;
